import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';

export interface FiscalDeviceItem {
    readonly id: number;
    readonly name: string;
    readonly paymentMethodsParameters: {
        readonly mappings: { mapped: string; paymentMethodId: number; }[];
    };
    readonly vatRatesParameters: {
        readonly mappings: { mapped: string; vatRateId: number; value: number }[];
        readonly technicalZeroId: number;
        readonly technicalZero: string;
    };
    readonly default: boolean;
}

interface FiscalDeviceInternalItem {
    readonly id: number;
    readonly name: string;
    readonly paymentMethodsParameters: {
        readonly mappings: {
            readonly mapped: string;
            readonly id: number;
        }[];
    };
    readonly vatRatesParameters: {
        readonly mappings: {
            readonly mapped: string;
            readonly id: number;
            readonly value: number;
        }[];
        readonly technicalZero: string;
    };
    readonly default: boolean;
    readonly version: string;
}

export class FiscalDeviceQuery extends Query<FiscalDeviceItem[]> { }

export class FiscalDeviceQueryHandlerBase implements QueryHandler<FiscalDeviceQuery, FiscalDeviceItem[]> {
    private static Url = TaggedUrl.join('system/devices', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(_: FiscalDeviceQuery): Promise<FiscalDeviceItem[]> {
        const { data } = await this.http.get<{ items: FiscalDeviceInternalItem[]; }>(FiscalDeviceQueryHandlerBase.Url);
        return data.items.map(i => {
            let paymentMethodsParameters: any = null;
            if (i.paymentMethodsParameters) {
                const mappings = i.paymentMethodsParameters.mappings.map(m => {
                    return {
                        mapped: m.mapped,
                        paymentMethodId: m.id
                    };
                });
                paymentMethodsParameters = {
                    mappings: mappings
                };
            }
            let vatRatesParameters: any = null;
            if (i.vatRatesParameters) {
                const mappings = i.vatRatesParameters.mappings.map(m => {
                    return {
                        mapped: m.mapped,
                        vatRateId: m.id,
                        value: typeof m.value !== void 0 ? m.value : null
                    };
                });
                vatRatesParameters = {
                    mappings: mappings,
                    technicalZero: typeof i.vatRatesParameters.technicalZero !== void 0 ? i.vatRatesParameters.technicalZero : null,
                };
            }

            return {
                id: i.id,
                default: i.default,
                name: i.name,
                paymentMethodsParameters: paymentMethodsParameters,
                vatRatesParameters: vatRatesParameters
            };
        });
    }
}
